import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL;

export const trackCTA = (section) => {
  axios.post(`${API}/api/track/cta`, { section }).catch(() => {});
};

export const fetchMemberCount = async () => {
  const res = await axios.get(`${API}/api/telegram/members`);
  return res.data.count;
};
